<template>
  <div class="selected-work of-h">    

<div class="work-wrap d-f fd-c pad-m">

        <div class="work w-100 of-h">
            <router-link to="/work/coop">

                <div class="img-wrapper col-1 bg-black">
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FCoop_cover.jpg?alt=media&token=bbaee9f0-ab95-4bb3-bdda-d2c8c4e926ee" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">Coop</div>
                        <div class="ws-pre"> — </div>
                        <div>Grocery Store Chain</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Web Design, App Design, Design System</div>
                    </div>
                </div>

            </router-link>
        </div>

        <div class="work w-100 of-h">
            <router-link to="/work/bambuser">

                <div class="img-wrapper col-1 bg-black">
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FBambuser_mock%202%402x.webp?alt=media&token=e90e3fe2-d044-4f4d-b280-4ec0047cb44c" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">Bambuser</div>
                        <div class="ws-pre"> — </div>
                        <div>Live Video Shopping</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Web Design, App Design, Design System</div>
                    </div>
                </div>

            </router-link>
        </div>


        <div class="work w-100 of-h">
            <router-link to="/work/ticker">

                <div class="img-wrapper col-1 bg-black">
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FFrame%2026%204.jpg?alt=media&token=8d9372ae-38a8-484c-bcbd-1d03b5680ff4" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">Ticker</div>
                        <div class="ws-pre"> — </div>
                        <div>Financial Investment Platform</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Concept, Brand Design, Digital Design.</div>
                    </div>
                </div>

            </router-link>
        </div>

        <div class="work w-100 of-h">
            <router-link to="/work/tv4play">

                <div class="img-wrapper col-1 bg-black">
                    <!-- <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FCover%20-%20TV4%20Play.webp?alt=media&token=93b96ade-4499-4a7c-ad42-e62072965996" alt=""> -->
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FTV4_cover_LR.jpg?alt=media&token=abe56324-1a76-426a-a415-8a99cb286e71" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">TV4 Play</div>
                        <div class="ws-pre"> — </div>
                        <div>Streaming Platform</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Web Design, App Design, TV Design, Design System</div>
                    </div>
                </div>

            </router-link>
        </div>


        <div class="work w-100 of-h">
            <router-link to="/work/algorhythm">

                <div class="img-wrapper col-1 bg-black">
                    <!-- <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FFrame%2026.jpg?alt=media&token=dd56474e-53ec-47ff-a22f-4fb44c2bab24" alt=""> -->
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FAlgo_mock.jpg?alt=media&token=dd887e6b-5e11-4d74-94ea-a2d72cb73de7" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">Algorhythm</div>
                        <div class="ws-pre"> — </div>
                        <div>Music Streaming Platform</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Concept, Brand Design, Digital Design, Programming</div>
                    </div>
                </div>

            </router-link>
        </div>

        <div class="work w-100 of-h">
            <router-link to="/work/revir">
                <div class="img-wrapper col-1 bg-black">
                    <img class="w-100 reveal" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/thumbs%2FGroup%2069%402x.jpg?alt=media&token=7d3c8b56-264e-4e2a-b852-17c423be3d38" alt="">
                </div>

                <div class="work-text">
                    <div class="d-f">
                        <div class="tt-uc">Revir</div>
                        <div class="ws-pre"> — </div>
                        <div>Apparel Brand</div>
                    </div>
                    <div class="d-f">
                        <div class="grey">Concept, Brand Design, Apparel Design, Photography, Digital Design, Programming</div>
                    </div>
                </div>
                
            </router-link>
        </div>

</div>

  </div>
</template>

<script>

export default {
  name: 'SelectedWork',
  data() {
    return {}
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll (event) {
      // Any code to be executed when the window is scrolled
      this.reveal()
    },
    reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = windowHeight / 2;
            if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
            } else {
            reveals[i].classList.remove("active");
            }
        }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";


</style>
